var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6474 1.6167C11.0566 1.6167 11.4489 1.78009 11.7353 2.06884L13.6734 4.0069C13.962 4.29545 14.1241 4.6868 14.1241 5.09487C14.1241 5.50294 13.962 5.8943 13.6734 6.18285L6.59747 13.2565C6.16091 13.7601 5.54209 14.0695 4.83315 14.1182H1.62402V13.4932L1.62605 10.8588C1.6793 10.1997 1.98569 9.58691 2.45308 9.17509L9.55864 2.06959C9.84677 1.77972 10.2386 1.6167 10.6474 1.6167ZM4.78901 12.8697C5.1229 12.8461 5.4337 12.6907 5.68327 12.4052L10.4095 7.67902L8.06298 5.33245L3.30909 10.0852C3.05587 10.3092 2.89922 10.6225 2.87402 10.9091V12.8685L4.78901 12.8697ZM8.94697 4.44867L11.2933 6.79514L12.7895 5.29896C12.8436 5.24484 12.8741 5.17142 12.8741 5.09487C12.8741 5.01833 12.8436 4.94491 12.7895 4.89078L10.8497 2.95098C10.7962 2.89704 10.7234 2.8667 10.6474 2.8667C10.5714 2.8667 10.4985 2.89704 10.445 2.95098L8.94697 4.44867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1eb1b0ef.svg";
export { ForwardRef as ReactComponent };